// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-about-js": () => import("./../../../src/pages/about.js" /* webpackChunkName: "component---src-pages-about-js" */),
  "component---src-pages-apply-js": () => import("./../../../src/pages/apply.js" /* webpackChunkName: "component---src-pages-apply-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-article-post-js": () => import("./../../../src/templates/articlePost.js" /* webpackChunkName: "component---src-templates-article-post-js" */),
  "component---src-templates-react-article-js": () => import("./../../../src/templates/reactArticle.js" /* webpackChunkName: "component---src-templates-react-article-js" */)
}

